import React from "react";
import { Box } from "reflexbox";

export function GuideSection({ children, ...props }) {
  return (
    <Box as="section" mb={[20, 30]} {...props}>
      {children}
    </Box>
  );
}
